module.exports = __webpack_public_path__ + "img/daohang-gif.c5dbc349.gif";